(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("storefrontSettings", {
        templateUrl: "app/settings/storefront/storefrontSettings.component.html",
        controller: ["tenantFeaturesResource", "tierPriceResource", "$rootScope", "$state", "$timeout", "$translate", "$uibModal", "messageService", StorefrontSettingsCtrl],
        controllerAs: "vm"
    });
    function StorefrontSettingsCtrl(tenantFeaturesResource, tierPriceResource, $rootScope, $state, $timeout, $translate, $uibModal, messageService) {
        var vm = this;
        vm.true = true;
        vm.saving = false;
        vm.loading = true;
        vm.lockPaymentButtons = false;
        vm.tierPrices = [];
        vm.storefront = {
            storefrontEnabled: false
        };
        vm.currencies = ["AUD", "BRL", "CAD", "CZK", "DKK", "EUR", "HKD", "HUF", "ILS", "JPY", "MYR", "MXN", "TWD", "NZD", "NOK", "PHP", "PLN", "GBP", "RUB", "SGD", "SEK", "CHF", "THB", "USD"];
        var lang = $translate.proposedLanguage() || $translate.use();
        lang = lang.replace("-", "_");
        vm.tinymceOptions = {
            resize: true,
            height: 200,
            forced_root_block: false,
            content_css: "//maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css",
            menubar: false,
            fontsize_formats: "10px 12px 13px 14px 16px 18px 20px 22px 24px",
            toolbar: "bold | fontsizeselect",
            language: lang
        };
        vm.saveReceipt = saveReceipt;
        load();
        //////////////////////////////////////////////////////////////////////////
        function load() {
            tenantFeaturesResource.getTenantStorefront(function (data) {
                vm.storefront.storefrontEnabled = data.storefrontEnabled;
                vm.storefront.storefrontInventoryEnabled = data.storefrontInventoryEnabled;
                vm.storefront.storefrontInventoryAssignToOrganization = data.storefrontInventoryAssignToOrganization;
                vm.storefront.storefrontCurrency = data.storefrontCurrency;
                vm.paymentMethods = data.paymentMethods;
                vm.tierPrices = data.tierPrices;
                vm.receipt = data.receipt;
                $timeout(function () {
                    vm.loading = false;
                }, 200);
            });
        }
        vm.onChange = function (newValue) {
            if (vm.saving)
                return;
            vm.saving = true;
            vm.storefront.storefrontEnabled = newValue;
            $timeout(function () {
                updateTenantStorefront();
            }, 300);
        };
        vm.onChangeInventory = function (newValue) {
            if (vm.saving)
                return;
            vm.saving = true;
            vm.storefront.storefrontInventoryEnabled = newValue;
            $timeout(function () {
                updateTenantStorefront();
            }, 300);
        };
        vm.onChangeAssignToOrganization = function () {
            tenantFeaturesResource.updateTenantStorefront(vm.storefront, function () {
                vm.saving = false;
            }, function (error) {
                messageService.error(error);
                vm.saving = false;
            });
        };
        vm.onChangeCurrency = function () {
            $timeout(function () {
                updateTenantStorefront();
            }, 300);
        };
        function updateTenantStorefront() {
            tenantFeaturesResource.updateTenantStorefront(vm.storefront, function (result) {
                if (result.value)
                    $rootScope.$broadcast("reloadTenantSettings");
                else
                    messageService.error("common.genericError");
                vm.saving = false;
            }, function (error) {
                messageService.error(error);
                vm.saving = false;
            });
        }
        vm.configure = function (paymentMethod) {
            $state.go("main.settings.paymentMethod".concat(paymentMethod.name), paymentMethod);
        };
        function saveReceipt() {
            if (vm.saving)
                return;
            vm.saving = true;
            tenantFeaturesResource.updateTenantStorefrontReceipt(vm.receipt, function () {
                messageService.success("common.changesSaved");
                vm.saving = false;
            }, function (error) {
                messageService.error(error);
                vm.saving = false;
            });
        }
        /////// TIER /////////////////
        vm.addTier = function () {
            var modal = $uibModal.open({
                templateUrl: "app/settings/storefront/tierPrice/tierPriceModalView.html",
                controller: "TierPriceModalCtrl as vm",
                resolve: {
                    tierPrice: function () {
                        return null;
                    }
                }
                //animation: false
            });
            modal.result.then(function () {
                reloadTiers();
            }).catch(angular.noop);
        };
        vm.editTier = function (tier) {
            var modal = $uibModal.open({
                templateUrl: "app/settings/storefront/tierPrice/tierPriceModalView.html",
                controller: "TierPriceModalCtrl as vm",
                resolve: {
                    tierPrice: function () {
                        return tier;
                    }
                }
                //animation: false
            });
            modal.result.then(function () {
                reloadTiers();
            }).catch(angular.noop);
        };
        vm.reorderTier = function () {
            var modal = $uibModal.open({
                templateUrl: "app/settings/storefront/tierPrice/reorderTierPriceModalView.html",
                controller: "ReorderTierPriceModalCtrl as vm",
                resolve: {
                    tierPrices: function () {
                        return angular.copy(vm.tierPrices);
                    }
                }
                //animation: false
            });
            modal.result.then(function () {
                reloadTiers();
            }).catch(angular.noop);
        };
        vm.tierPriceSortableOptions = {
            handle: '.cursor-move',
            axis: "y",
            stop: function () {
                vm.saveTierOrder();
            }
        };
        vm.saveTierOrder = function () {
            var tierPrices = angular.copy(vm.tierPrices);
            // changed from parseInt to +var
            for (var i in tierPrices) {
                if (tierPrices.hasOwnProperty(i)) {
                    tierPrices[i].order = +i + 1;
                }
            }
            tierPriceResource.saveOrder({ tierPrices: tierPrices }, function () {
                messageService.success("common.changesSaved");
            }, function () {
                messageService.error("common.genericError");
            });
        };
        function reloadTiers() {
            tenantFeaturesResource.getTenantStorefrontTierPrices(function (data) {
                vm.tierPrices = data;
            });
        }
    }
})();
